/* tslint:disable:no-string-literal */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Route, Switch } from 'react-router-dom'

/**
 *     Import
 *     - Containers
 */
import Login from '../containers/pages/Login/Login'
import Forgot from '../containers/pages/Login/Forgot'
import Recover from '../containers/pages/Login/Recover'
import Logout from '../containers/pages/Logout/Logout'
import UserAccount from '../containers/pages/UserAccount/UserAccount'
import Accounts from '../containers/pages/Accounts/Accounts'
import Dashboard from '../containers/pages/Dashboard/Dashboard'
import ManageAgency from '../containers/pages/ManageAgency/ManageAgency'
import ManageAgencyDetail from '../containers/pages/ManageAgency/ManageAgencyDetail'
import Clients from '../containers/pages/Clients/Clients'
import AddUser from '../containers/pages/ManageAgency/AddUser'
import Quote from '../containers/pages/Quote/Quote'
import ViewQuote from '../containers/pages/Quote/ViewQuote'
import EditQuote from '../containers/pages/Quote/EditQuote'
import ViewPolicy from '../containers/pages/Policies/View/View'
import MTA from '../containers/pages/Policies/MTA/MTA'
import MTAConfirm from '../containers/pages/Policies/MTA/MTAConfirm'
import Navbar from '../containers/common/Navbar/Navbar'
import Search from '../containers/pages/Search/Search'
import EditRenewals from '../containers/pages/Renewals/EditRenewals/EditRenewals'
import Renewals from '../containers/pages/Renewals/Renewals'
import BindQuote from '../containers/pages/Clients/BindQuote'
import RenewalSummary from '../containers/pages/Renewals/Summary/Summary'

import RouteValidator from '../containers/RouteValidator'
import AdminValidator from '../containers/AdminValidator'

/**
 *     Import
 *     - Components
 */
import Icons from '../images/icons/Icons'
import { GridLines } from '../components/common/GridLines/GridLines'

export default class App extends React.Component<any, any> {
    constructor(props: any) {
        super(props)

    }

    componentDidMount() {
        ['wheel', 'mousewheel'].forEach(event => {
            document.addEventListener(event, function () {
                const activeElement = document.activeElement || {}
                if (activeElement['type'] && activeElement['type'] === 'number') {
                    (document.activeElement as HTMLElement).blur()
                }
            })
        });

        ['keydown', 'keydown', 'keypress'].forEach(event => {
            document.addEventListener(event, function (e: any) {
                const activeElement = document.activeElement || {}
                if (activeElement['type'] && activeElement['type'] === 'number' &&
                    (e.key === 38 || e.key === 40 || e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
                    e.preventDefault()
                }
            })
        })
    }

    render() {
        return (
            <Switch>
                <Route exact={true} path="/login" component={Login} />
                <Route exact={true} path="/logout" component={Logout} />
                <Route exact={true} path="/forgot" component={Forgot} />
                <Route exact={true} path="/recover/:token?" component={Recover} />
                <RouteValidator>
                    <GridLines hidden={true} />
                    <Navbar />
                    <Route exact={true} path="/stylesheet/icons" component={Icons} />
                    <Route exact={true} path="/user/account" component={UserAccount} />
                    <Route exact={true} path="/(dashboard|)" component={Dashboard} />
                    <Route exact={true} path="/accounts" component={Accounts} />
                    <Route exact={true} path="/clients" component={Clients} />
                    <Route exact={true} path="/clients/quotes" component={Clients} />
                    <Route exact={true} path="/clients/quotes/view/:quoteId?" component={ViewQuote} />
                    <Route exact={true} path="/clients/quotes/bound/:policyId?" component={BindQuote} />
                    <Route exact={true} path="/clients/quotes/edit/:id?" component={EditQuote} />
                    <Route exact={true} path="/clients/policies" component={Clients} />
                    <Route exact={true} path="/clients/policies/view/:policyId?" component={ViewPolicy} />
                    <Route exact={true} path="/clients/policies/mta/:id?" component={MTA} />
                    <Route exact={true} path="/clients/policies/mta/:id/summary/:mtaid?" component={MTAConfirm} />
                    <Route exact={true} path="/search" component={Search} />
                    <Route exact={true} path="/renewals/edit/:id?" component={EditRenewals} />
                    <Route exact={true} path="/renewals/bind/:id?" component={RenewalSummary} />
                    <Route exact={true} path="/renewals" component={Renewals} />

                    <Route path="/agent-admin/manage-agency" component={AdminValidator} />
                    <Route exact={true} path="/agent-admin/manage-agency" component={ManageAgency} />
                    <Route exact={true} path="/agent-admin/manage-agency/user/:id?" component={ManageAgencyDetail} />
                    <Route exact={true} path="/agent-admin/manage-agency/add-user" component={AddUser} />

                    <Route path="/quote/:quoteId?/:step?" component={Quote} />
                </RouteValidator>
            </Switch>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/App.tsx